import { useState, useEffect, useRef } from 'react';

const useCountdownTimer = (initialSeconds: number, onComplete: () => void) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isActive, setIsActive] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  // Start or resume
  const start = () => {
    if (seconds > 0) setIsActive(true);
  };

  // Pause
  const pause = () => setIsActive(false);

  // Reset to initial value
  const reset = (newInitial?: number) => {
    setIsActive(false);
    setSeconds(newInitial ?? initialSeconds);
  };

  // Update initial duration (only when not running)
  const setDuration = (newDuration: number) => {
    if (!isActive) {
      setSeconds(newDuration);
    }
  };

  useEffect(() => {
    if (isActive && seconds > 0) {
      intervalRef.current = setInterval(() => {
        setSeconds(prev => prev - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsActive(false);
      onComplete();
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isActive, seconds]);

  return {
    seconds,
    isActive,
    start,
    pause,
    reset,
    setDuration,
  };
};

export { useCountdownTimer };
